"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "URL", {
  enumerable: true,
  get: function () {
    return _url.default;
  }
});
exports.cookie = void 0;
Object.defineProperty(exports, "debug", {
  enumerable: true,
  get: function () {
    return _diagnostics.default;
  }
});
exports.json = void 0;
Object.defineProperty(exports, "registerKeyboardNavListener", {
  enumerable: true,
  get: function () {
    return _registerKeyboardNav.registerKeyboardNavListener;
  }
});
Object.defineProperty(exports, "request", {
  enumerable: true,
  get: function () {
    return _request.default;
  }
});
exports.storage = void 0;
var _request = _interopRequireDefault(require("@godaddy/request"));
var _diagnostics = _interopRequireDefault(require("./utils/diagnostics"));
var json = _interopRequireWildcard(require("./utils/json"));
exports.json = json;
var _url = _interopRequireDefault(require("./utils/url"));
var _registerKeyboardNav = require("./utils/register-keyboard-nav");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const cookie = exports.cookie = require('koekiemonster')();
//
// @deprecated
// We have moved on from `cookie-monster` as it is no longer maintained
// Polyfill to cookie-monster@0.1.1
// See: https://github.com/kahnjw/cookie-monster/compare/0.1.1...0.2.1
//
cookie.get = cookie.getItem;
cookie.set = cookie.setItem;
cookie.remove = cookie.removeItem;
cookie.clear = null;

//
// @deprecated
// sessionStorage is now available on window in all browsers in our
// target support matrix. However, since it was previously exposed
// prior to this we must re-expose it in this fashion.
//
let storage = exports.storage = void 0;
if (typeof window !== 'undefined') {
  exports.storage = storage = window.sessionStorage;
}